<template>
  <v-app>
    <vue-headful
      title="Alphazento Home"
      description="Alphazento the best e-commerce platform over Laravel"
    />
    <v-navigation-drawer v-model="drawer" color="green lighten-3" app>
      <v-list>
        <v-list-item v-for="item in menus" :key="item.title">
          <v-list-item-content>
            <v-list-item-title>
              <a v-if="item.ext_url" v-bind:href="item.ext_url">
                {{ item.title }}
              </a>
              <router-link v-else :to="item.url">{{ item.title }}</router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-container class="z-app-content-light">
      <v-app-bar
        app
        color="#2f495e"
        dark
        class="z-app-bar"
        v-resize="onResize"
        :height="appBarHeight"
      >
        <v-app-bar-nav-icon
          class="hidden-md-and-up"
          icon
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>

        <div class="d-flex align-center z-app-logo">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 312 335"
            width="40"
            height="40"
            class="logo-svg"
          >
            <path
              id="Shape 2"
              class="shp0"
              d="M0 335C180.51 62.98 167 -94.55 187 64C207 222.55 79.46 227.14 172 225C264.54 222.86 14.02 306.65 115 301C215.98 295.35 437.27 284.27 219 313"
            />
          </svg>
          <span>ALPHAZENTO</span>
        </div>
        <v-spacer></v-spacer>
        <ul class="z-app-bar-menu hidden-sm-and-down">
          <li v-for="item of menus" :key="item.title">
            <a v-if="item.ext_url" v-bind:href="item.ext_url">
              {{ item.title }}
            </a>
            <router-link v-else :to="item.url">{{ item.title }}</router-link>
          </li>
        </ul>
        <v-spacer></v-spacer>
        <!-- desktop search bar -->
        <!-- <v-text-field
          v-model="searchText"
          filled
          rounded
          dense
          style="max-width: 300px;"
          placeholder="Search..."
          class="z-search-bar"
          append-icon="mdi-magnify"
        />-->
      </v-app-bar>
    </v-container>
    <router-view></router-view>
    <v-content class="z-app-content-deep footer-bar">
      <footer-bar></footer-bar>
    </v-content>
  </v-app>
</template>

<script>
import FooterBar from "./components/footerbar";
import vueHeadful from "vue-headful";

export default {
  name: "App",

  components: { FooterBar, vueHeadful },

  data: () => ({
    searchText: "",
    appBarHeight: "63px",
    menus: [
      {
        title: "Home",
        url: "/",
      },
      {
        title: "Guide",
        url: "/guide/introduction",
      },
      {
        title: "API",
        ext_url: "/api/index.html",
      },
      {
        title: "Extensions",
        ext_url: "/extensions-market",
      },
      {
        title: "Faq",
        url: "/faq",
      },
      {
        title: "Live Demo",
        ext_url: "https://example.alphazento.com",
      },
    ],
    drawer: false,
  }),

  methods: {
    onResize() {
      if (window.innerWidth >= 800) {
        this.appBarHeight = "96px";
      } else {
        this.appBarHeight = "63px";
      }
    },
  },
};
</script>

<style lang="scss">
@import "./theme.scss";
</style>
